import { performRequestThird } from 'common/apiHandler';
import { default as apiEndPoints } from 'common/apiEndPoints';
import { getTenantDetails } from 'utils/utils';

// Manage tag-in (create or update)
export const manageTagIn = async (tagInData, excludeFromLoading = false) => {
  const [tenantId] = getTenantDetails();

  // Format the data according to API requirements
  const requestData = {
    tenant_id: tenantId,
    ...tagInData,
  };

  let url = apiEndPoints.manageTagIn;
  return performRequestThird(apiEndPoints.methodType.POST, url, requestData, '', true, excludeFromLoading);
};

// Get current tag-in assignment
export const getCurrentTagIn = async (excludeFromLoading = false, targetUserId = null) => {
  const [tenantId] = getTenantDetails();
  let url = `${apiEndPoints.getCurrentTagIn}?tenant_id=${tenantId}`;

  // Add target_user_id for admin managing other users
  if (targetUserId) {
    url += `&target_user_id=${targetUserId}`;
  }

  return performRequestThird(apiEndPoints.methodType.GET, url, {}, '', true, excludeFromLoading);
};

// Remove tag-in assignment
export const deleteTagIn = async (excludeFromLoading = false, targetUserId = null) => {
  const [tenantId] = getTenantDetails();
  const requestData = {
    tenant_id: tenantId,
  };

  // Add target_user_id for admin managing other users
  if (targetUserId) {
    requestData.target_user_id = targetUserId;
  }

  let url = apiEndPoints.deleteTagIn;
  return performRequestThird(apiEndPoints.methodType.POST, url, requestData, '', true, excludeFromLoading);
};
